import React from 'react'
import { connect } from 'react-redux'

import { getIsLoggedIn } from 'selectors/authSelectors'
import { getFBPixelId } from 'selectors/appStatusSelectors'

import { getEnvName } from 'config/env.js'

const bootstrap = () => {
  ;(function(f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
}

export class FacebookPixel extends React.Component {
  initPixel() {
    let { shouldTrack, fbPixelId } = this.props

    if (shouldTrack && typeof window.fbq === 'function') {
      window.fbq('init', fbPixelId)
    } else {
      console.warn('FB PIXEL Init', fbPixelId)
    }
  }

  trackPageView() {
    let { shouldTrack, fbPixelId } = this.props

    if (shouldTrack && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView')
    } else {
      console.warn('FB PIXEL PageView', fbPixelId)
    }
  }

  componentDidMount() {
    bootstrap()

    this.initPixel()
    this.trackPageView()
  }

  render() {
    return null
  }
}

function mapStateToProps(state, op) {
  let fbPixelId = getFBPixelId(state)

  return {
    ...op,
    fbPixelId,
    pathname: window.location.pathname, // used to trigger re-render
    search: window.location.search, // used to trigger re-render
    shouldTrack:
      !!fbPixelId &&
      !getIsLoggedIn(state) &&
      getEnvName() === 'production',
  }
}

export default connect(mapStateToProps)(FacebookPixel)

/*
  example noscript code NOT HOOKED UP

  <noscript>
    <img height="1" width="1"
    src="https://www.facebook.com/tr?id=479227976199205&ev=PageView&noscript=1"/>
  </noscript>
*/
